import React, { Component } from "react";
import { Dropdown, Header, Icon } from "semantic-ui-react";
import "./SiteSearch.css";

class SiteSearch extends Component {
  render() {
    let siteData = [];
    if (this.props.sites.length > 0) {
      siteData = this.props.sites.map(item => {
        return {
          key: item.siteUrl,
          value: item.siteUrl,
          text: item.siteUrl
        };
      });
    }
    let { value } = siteData;
    return (
      <div className="SiteSearch">
        <Header size="huge" as="h1" textAlign="center">
          <Icon name="search" />
          Search for Crawl Errors
        </Header>
        <div className="SearchBar">
        <Dropdown
          placeholder="Select Website"
          fluid
          search
          selection
          options={siteData}
          onChange={this.props.handleChange}
          value={value}
        />
        </div>
      </div>
    );
  }
}

export default SiteSearch;



// WEBPACK FOOTER //
// ./src/components/SiteSearch/SiteSearch.js